import { render } from "./SingleTtrOdnostoronCard.vue?vue&type=template&id=875fb758&scoped=true"
import script from "./SingleTtrOdnostoronCard.vue?vue&type=script&lang=js"
export * from "./SingleTtrOdnostoronCard.vue?vue&type=script&lang=js"

import "./SingleTtrOdnostoronCard.vue?vue&type=style&index=0&id=875fb758&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875fb758"]])

export default __exports__